// extracted by mini-css-extract-plugin
export default {"strip":"InTaxIncomeSummary_strip__-5+AA"};